import { ModalBodyWrapper } from './AccountModal'
import { FieldCheckBox } from './FieldCheckBox'
import { useAccountLayoutContext } from './AccountProfileContext'

/**
 *
 * @param {{brands: string[],connectionId: number, handleToggle: () => void, selectedBrands: string[], brandsMap: any}} props
 * @returns
 */
export const FormAddBrand = (props) => {
  const { omneoClient } = useAccountLayoutContext()

  return (
    <ModalBodyWrapper
      config={{
        submitButtonText: 'Save',
        handleToggle: props.handleToggle,
        submitCallback: async (e) => {
          e.preventDefault()
          try {
            const payload = []
            const data = new FormData(e.currentTarget)
            data.forEach((v, k) => {
              payload.push(v)
            })
            const child = omneoClient.client.profile.Connection(props.connectionId)
            await omneoClient.updateFavouriteBrands(child, payload)
            props.handleRefetch()
            props.handleToggle()
          } catch (err) {
            console.log(err)
          }
        }
      }}
    >
      <div className={'grid grid-cols-2 gap-4 md:grid-cols-3'}>
        {Object.keys(props.brandsMap).map((brand, i) => (
          <FieldCheckBox
            {...{
              name: brand,
              value: brand,
              required: false,
              checked: props.selectedBrands.includes(brand)
            }}
          >
            <div className={'flex w-full items-center justify-center'}>
              <div className={'aspect-1 max-h-8 w-16'}>
                <img src={props.brandsMap[brand]} className={'h-full w-full object-contain'} />
              </div>
            </div>
          </FieldCheckBox>
        ))}
      </div>
    </ModalBodyWrapper>
  )
}
